<template>
  <div id="nav-menu-admin">
    <header>
      <div class="shadow">
        <b-navbar style="background-color: #003168;">
          <b-navbar-brand href="#"><img src="./../../../assets/images/footer-mobile.png"></b-navbar-brand>

          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav class="ml-auto">
              <b-nav-item-dropdown right>
                <template v-slot:button-content>
                  <i class="fas fa-user"></i> {{userInfo.firstName}} {{userInfo.lastName}}
                </template>
                <b-dropdown-item href="#" @click="logout()"><i class="fas fa-sign-out-alt"></i> Sign Out</b-dropdown-item>
              </b-nav-item-dropdown>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>
    </header>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userInfo: JSON.parse(localStorage.getItem('agenthub-admin'))
      }
    },
    methods: {
      logout() {
        let loading = this.$loading.show()
        this.$http.post(this.$app.baseURL + this.$path.userLogout, '', {
          'headers': {
            'token': this.userInfo.token
          }
        }).then(
          () => {
            loading.hide()
            this.$router.replace('/agentclound-login')
          }, () => {
            loading.hide()
            this.$router.replace('/agentclound-login')
          }
        )
      }
    }
  }
</script>

<style scoped>
a.dropdown-toggle{
  color: #fff !important;
}
</style>